// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7df3c3c5","977":"281978a4"}[chunkId] + ".chunk.js";
};